// extracted by mini-css-extract-plugin
module.exports = {"firstFold":"firstFold_firstFold__MvHhs","bgImage":"firstFold_bgImage__jtC1m","heading":"firstFold_heading__szYwo","subParagraph":"firstFold_subParagraph__2OLnG"};